// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seamless-puzzle-titleWrap-10779{padding-bottom:.45rem}.seamless-puzzle-imageContent-81c57{align-items:center;display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrap": "seamless-puzzle-titleWrap-10779",
	"imageContent": "seamless-puzzle-imageContent-81c57"
};
export default ___CSS_LOADER_EXPORT___;
